/* Dynamic Plot code copyright 2024 (c) Tuva Labs Inc.
 *
 * created by cmiller
 */
import ReactDOM from "react-dom";
import AttributeCard from "../../../components/elem-play/editable/AttributeCard";

export default class AttributeView {
    constructor(Dyn, container) {
        // references to other objects
        this.Dyn = Dyn;
        this.container = container;

        // our stuff
        this.bounds = new Dyn.mathUtil.Rect(0, 0, 0, 0); // area where big cards are allowed
    }

    destroy() {
        this.Dyn = null;
        this.container = null;
        // Properly destroy this.outline and this.htmlRoot
        this.htmlRoot.unmount();
        this.outline.remove();
    }

    initVisuals() {
        // Attribute card
        const rect = this.bounds;
        const outline = this.container.paper.foreignObject(
            "",
            rect.x,
            rect.y,
            rect.width,
            rect.height
        );
        const body = outline.node.firstChild;
        body.style.height = "100%";
        const container = document.createElement("div");
        container.classList.add("tde-fill", "tde-bg-color");
        body.appendChild(container);
        // Render using react
        const root = ReactDOM.createRoot(container);
        root.render(<AttributeCard Dyn={this.Dyn} />);
        this.outline = outline;
        this.htmlRoot = root;
        this.updateVisuals();
    }

    updateVisuals() {
        const rect = this.bounds;

        const width = AttributeCard.width;
        const height = AttributeCard.height;
        this.outline.attr({
            x: rect.x + 50,
            y: rect.centerY() - height / 2,
            width: width,
            height: height,
        });
        this.outline.toFront();
    }

    resize(newSize, inPlotBounds) {
        let Dyn = this.Dyn;
        this.bounds.copyRect(newSize);
        this.bounds.addDebugRect(this.container.paper, "red");
        Dyn.assertValidRect(this.bounds);
        this.updateVisuals();
    }

    hide() {
        this.Dyn.plotUtil.showOrHideElement( this.outline, false );
    }

    show() {
        this.Dyn.plotUtil.showOrHideElement( this.outline, true );
    }
}
